import { api } from '@api/api2';
import type { GetTypePointPayload } from './types';

export const getList = (payload: GetTypePointPayload) =>
  api.no_vers('get', 'scud/get-compl-type', {
    ...payload,
    ...{ object: 'level' },
  });
